<!--
*@业务查询
*@author Ys
*@date 2023/8/15 08:11
-->
<template>
  <div id="mainContainer">
    <div id="headTitle"></div>
    <el-card id="box-card" :style="{height:tabHeight}">
      <br>
      <p id="titileStyle">业务查询</p>
      <div style="margin-top: 35px;">
        <el-form :inline="true" :model="queryData" ref="filtersForm" style="padding: 5px 0 0 5px"
                 @submit.native.prevent @keyup.enter.native="filterQuery">
          <el-row>
            <el-form-item label="项目名称">
              <el-input size="mini" v-model="queryData.qkey" placeholder="项目名称" style="width: 200px;"
                        @keydown.enter.native="filterQuery()" clearable></el-input>
            </el-form-item>
            <el-form-item label="业务类型">
              <el-select clearable size="mini" v-model="queryData.ywlx" placeholder="请选择"
                         style="width: 250px;">
                <el-option-group v-for="group in ywlxOptions" :key="group.id" :label="group.name">
                  <el-option v-for="item in group.children" :key="item.id" :label="item.name"
                             :value="item.id"></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="filterQuery">查询</el-button>
            </el-form-item>
          </el-row>
        </el-form>
        <div id="FirstDiv">
          <div class="contentDiv">
            <div id="contentTitle">查询结果</div>
            <br><br>
            <el-row class="containerDiv" style="width: 98%;height: 440px">
              <el-table :data="tableData" height="480" style="overflow-y:auto"
                         border fit size="medium">
                <el-table-column align="center" label="序号" type="index" width="50">
                  <template slot-scope="scope">
                    <span>{{scope.$index+1}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="项目名称" prop="YWNAME" align="center" width="300px"></el-table-column>
                <el-table-column label="所在节点" prop="SZJD" align="center"  width="180px"></el-table-column>
                <el-table-column label="是否挂起" prop="SFGQ" align="center" width="100px">
                  <template slot-scope="scope">
                      <span v-if="scope.row.SFGQ==='否'"  style="color: #36a985;font-weight: bold">否</span>
                      <span v-else-if="scope.row.SFGQ==='是'" style="color: #fd6c29;font-weight: bold">是</span>
                  </template>
                </el-table-column>
                <el-table-column label="是否终止" prop="SFZZ" align="center" width="100px">
                  <template slot-scope="scope">
                    <span v-if="scope.row.SFZZ==='否'"  style="color: #36a985;font-weight: bold">否</span>
                    <span v-else-if="scope.row.SFZZ==='是'" style="color: #fd6c29;font-weight: bold">是</span>
                  </template>
                </el-table-column>
                <el-table-column label="是否已办结" prop="SFBJ" align="center" width="100px">
                  <template slot-scope="scope">
                    <span v-if="scope.row.SFBJ==='否'"  style="color: #36a985;font-weight: bold">否</span>
                    <span v-else-if="scope.row.SFBJ==='是'" style="color: #fd6c29;font-weight: bold">是</span>
                  </template>
                </el-table-column>

                <el-table-column label="挂起原因" prop="GQYY" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.SFGQ==='是'" >{{scope.row.GQYY}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="终止原因" prop="REMARK" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.SFZZ==='是'" >{{scope.row.REMARK}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>

  import API from '../../api/ApiConfig'
  import {ajaxPost} from '../../util/AjaxhttpRequest'

  export default {
    name: 'YwQueryPage',
    props: [],
    components: {},
    data () {
      return {
        tableData: [],
        ywlxOptions: [],
        queryData: {},
        tabHeight: window.innerHeight - 100 + 'px',
        tableHeight: window.innerHeight - 100 + 'px',
      }
    },
    created () {

    },
    mounted () {
      this.getYwlxTree()
    },
    methods: {
      filterQuery () {
        this.queryYwxtBusiness()
      },
      queryYwxtBusiness () {
        if (!this.queryData.qkey) {
          this.$message.warning('请输入需要查询的业务【项目名称】')
          return
        }
        if (!this.queryData.ywlx) {
          this.$message.warning('请选择需要查询的【业务类型】')
          return
        }
        ajaxPost(API.YwxtProvider, 'queryYwxtBusiness', ['', JSON.stringify(this.queryData)]).then(result => {
          let res = JSON.parse(result)
          this.tableData=res;
        }).catch(err => {
          this.$message.error(err)
        })
      },
      getYwlxTree () {
        let ywlx=['0101','0201','0202','0203','0205','0306','0304','0305','0501','0503','0504','0505','0603'];
        ajaxPost(API.YwxtProvider, 'getYwlxTreeByPid', ['', JSON.stringify(ywlx)]).then(result => {
          this.ywlxOptions = JSON.parse(result)
        }).catch(err => {
          this.$message.error(err)
        })
      },

    },

  }
</script>

<style scoped>
  #mainContainer {
    background: url('../../assets/login_bj.jpg');
    background-size: 100% 100%;
    height: 100%;
    position: fixed;
    width: 100%;
    overflow: hidden;
  }

  #headTitle {
    width: 800px;
    margin: 3% auto;
    padding-top: 100px;
    /*background-image: url('../../../assets/toplogo.png');*/
    background-size: 100% 100%;
  }

  #titileStyle {
    font-family: SourceHanSansSC;
    font-weight: 700;
    font-size: 36px;
    color: rgb(32, 133, 234);
    font-style: normal;
    letter-spacing: 0px;
    line-height: 52px;
    text-decoration: none;
  }

  /deep/ .el-card {
    /*存在标题样式*/
    /*position: absolute; left: 50%; top: 58%;*/
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 80%;
    width: 90%;
  }

  #box-card {
    overflow-y: auto;
    width: 1458px;
    /*存在标题样式*/
    /*height: 750px;*/
    /*height: 850px;*/
    border-color: rgb(187, 187, 187);
    border-width: 1px;
    border-style: solid;
    border-radius: 5px;
    font-size: 14px;
    padding: 0px;
    text-align: center;
    line-height: 20px;
    font-weight: normal;
    font-style: normal;
    background: rgb(255, 255, 255);
  }


  #FirstDiv {
    position: absolute;
    left: 50%;
    top: 60%;
    transform: translate(-50%, -50%);
    overflow: auto;
    border-color: rgb(187, 187, 187);
    border-width: 1px;
    border-style: solid;
  }

  #contentTitle {
    border: 1px solid rgb(187, 187, 187);
    font-family: SourceHanSansSC;
    font-size: 28px;
    background: rgb(234, 234, 234);
    color: rgb(16, 16, 16);
    font-style: normal;
    letter-spacing: 0;
    line-height: 40px;
    text-decoration: none;
  }

  .contentDiv {
    width: 1279px;
    height: 534px;
    font-size: 14px;
    padding: 0px;
    text-align: center;
    line-height: 20px;
    font-weight: normal;
    font-style: normal;
    background: rgb(255, 255, 255);
  }

  .containerDiv {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }



</style>




// WEBPACK FOOTER //
// src/components/ywxt/YwQueryPage.vue